export const capitalizeFirstLetter = ([first, ...rest]) => `${first.toUpperCase()}${rest.join('')}`;
